import "./_select-asset-modal-list.scss";

import {List} from "@hipo/react-ui-toolkit";

import {AssetListItemData} from "../../../../asset/util/assetModels";
import SelectAssetModalListItem from "./item/SelectAssetModalListItem";

interface SelectAssetModalListProps {
  assetList: AssetListItemData[];
  onSelect: (asset: AssetListItemData) => void;
}

function SelectAssetModalList({assetList, onSelect}: SelectAssetModalListProps) {
  return (
    <List items={assetList} customClassName={"select-asset-modal-list"}>
      {(asset) => <SelectAssetModalListItem asset={asset} onSelect={onSelect} />}
    </List>
  );
}

export default SelectAssetModalList;
